import { createSelector } from '@ngrx/store';
import { BaseState } from '../base.state';

export const selectUWApprovalState = (state: BaseState) => state.uwApproval;

export const selectUWApprovalIsLoading = createSelector(
  selectUWApprovalState,
  (state) => state.isLoading
);